import { motion } from "framer-motion";
import { User, Users, Video, Route, Dumbbell, GraduationCap, MapPin } from "lucide-react";
import { GoldButton } from "./GoldButton";
import { PhoneMockup } from "./PhoneMockup";
import { Reveal, MaskedLine } from "./Reveal";

const AREAS = [
  { icon: User, title: "Persona", text: "Routine, journaling, preghiera, disciplina e crescita personale." },
  { icon: Users, title: "Community", text: "Aree dedicate a uomini e donne, single, coppie e connessioni autentiche." },
  { icon: Video, title: "Call di gruppo", text: "Incontri periodici con i Founder e con la community per approfondire temi, confrontarsi e fare domande." },
  { icon: Route, title: "Percorsi", text: "Crescita nell'identità, disciplina e maturità cristiana." },
  { icon: Dumbbell, title: "Allenamento", text: "Palestra, casa, corpo libero, outdoor ed Express, con diversi livelli." },
  { icon: GraduationCap, title: "Academy", text: "Formazione e contenuti di approfondimento." },
  { icon: MapPin, title: "Territorio", text: "Eventi, incontri, Connect Group, iniziative e connessioni reali tra i membri." },
];

export const TempioVivo = () => (
  <section className="relative bg-charcoal px-5 py-28 sm:px-8 lg:py-40" data-testid="tempio-vivo-section">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
          <span className="h-px w-10 bg-gold/60" /> Quello che ti aspetta dopo
        </p>
      </Reveal>
      <div className="mt-6 grid gap-14 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
        <div>
          <h2 className="font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.1}>Benvenuto in</MaskedLine>
            <MaskedLine delay={0.22}>
              <span className="text-gold">Tempio Vivo.</span>
            </MaskedLine>
          </h2>
          <Reveal delay={0.3} className="mt-8 max-w-2xl">
            <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">
              Non un gruppo WhatsApp. Non una pagina social.
            </p>
            <p className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-ivory sm:text-2xl">
              Un ecosistema cristiano costruito per accompagnare la persona nella vita reale.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.35} className="mx-auto w-full max-w-[280px] lg:max-w-[300px]">
          <PhoneMockup screen="home" />
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px border border-ivory/10 bg-ivory/10 sm:grid-cols-2" data-testid="ecosystem-grid">
        {AREAS.map((a, i) => (
          <motion.div
            key={a.title}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative bg-charcoal p-8 transition-colors duration-500 hover:bg-night ${i === AREAS.length - 1 ? "sm:col-span-2" : ""}`}
            data-testid={`ecosystem-card-${a.title.toLowerCase().replace(/\s/g, "-")}`}
          >
            <span className="absolute right-6 top-6 font-display text-sm font-bold text-ivory/15">
              {String(i + 1).padStart(2, "0")}
            </span>
            <a.icon className="h-6 w-6 text-gold transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.5} />
            <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-wide text-ivory">{a.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-ivory/55">{a.text}</p>
            <span className="mt-6 block h-px w-0 bg-gold transition-all duration-500 group-hover:w-full" />
          </motion.div>
        ))}
      </div>

      <div className="mt-28 text-center lg:mt-40">
        <h3 className="font-display font-bold uppercase leading-[1.08] tracking-tight" data-testid="tempio-vivo-closing">
          <MaskedLine className="text-3xl text-ivory sm:text-5xl lg:text-6xl">Non vogliamo tenerti</MaskedLine>
          <MaskedLine delay={0.15} className="text-3xl text-ivory sm:text-5xl lg:text-6xl">dentro uno schermo.</MaskedLine>
          <MaskedLine delay={0.35} className="mt-4 text-3xl sm:text-5xl lg:text-6xl">
            <span className="text-gold">Vogliamo costruire una realtà</span>
          </MaskedLine>
          <MaskedLine delay={0.5} className="text-3xl sm:text-5xl lg:text-6xl">
            <span className="text-gold">anche fuori dallo schermo.</span>
          </MaskedLine>
        </h3>
        <Reveal delay={0.6} className="mt-14">
          <GoldButton testId="tempio-vivo-cta-button" />
        </Reveal>
      </div>
    </div>
  </section>
);
